import PropTypes from 'prop-types';
import { Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import LinearProgress from '@material-ui/core/LinearProgress';
import { withStyles } from '@material-ui/core/styles';
import React from 'react';
import GS from '../grafsync/grafsync';
import { globalStyles as styles } from './style/gstheme';

class Maintenance extends React.Component {

  state = {
    startEdits: GS.outstandingEdits(),
    edits: GS.outstandingEdits()
  };

  componentDidMount() {
    this.hcTimeout = setTimeout(() => this.isStillSaving(), 100);
  }

  isStillSaving = () => {
    const edits =  GS.outstandingEdits();
    if (this.hcTimeout) clearTimeout(this.hcTimeout);
    this.setState({ edits });
    if (edits > 0) {
      this.hcTimeout = setTimeout(() => this.isStillSaving(), 100);
    }
    else {
      if (this.props.onDone) this.props.onDone();
    }
  };

  componentWillUnmount() {
    if (this.hcTimeout) clearTimeout(this.hcTimeout);
  }

  render() {

    const { classes } = this.props;
    const { edits, startEdits } = this.state;

    return (
      <React.Fragment>
        <Dialog open={true} aria-labelledby="maintenance-dialog-title" >
          <DialogTitle
            disableTypography
            className={classes.mainHeading}
            id="maintenance-dialog-title">Maintenance Mode</DialogTitle>
          <DialogContent style={{height: 200}}>
            <DialogContentText className={classes.dialogText} paragraph>Graphologi is now in maintenance mode.</DialogContentText>
            {edits > 0 &&
              <React.Fragment>
                <DialogContentText className={classes.dialogText}>Please wait before exiting. All edits must be processed first to avoid losing data.</DialogContentText>
                <Typography className={classes.mainHeading} style={{ textAlign: 'center', }}>{edits}</Typography>
                <LinearProgress color="secondary" className={classes.progress} variant="determinate" value={(startEdits - edits) / startEdits * 100} />
              </React.Fragment>
            }
          </DialogContent>
        </Dialog>
      </React.Fragment>
    );
  }
}

Maintenance.propTypes = {
  onDone: PropTypes.func,
  classes: PropTypes.object
};

export default withStyles(styles)(Maintenance);